import { HeadProps } from 'gatsby';
import React from 'react';
import favIcon from '../../../assets/images/favicon.ico';
import { safeParse } from '../../helpers/json';

type SEOProps = {
  stringPageInfo?: string;
} & Omit<HeadProps, 'pageContext'>;

export const SEO: React.FC<SEOProps> = ({ stringPageInfo, children }) => {
  const seo = safeParse(stringPageInfo);
  return (
    <>
      <title>{seo.navTitle || seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="pageTitle" content={seo.pageTitle || seo.title} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}

      <meta name="og:title" content={seo.pageTitle || seo.title} />
      <meta name="og:description" content={seo.description} />

      <link id="favicon-icon" rel="icon" href={favIcon} />
      <link
        rel="shortcut icon"
        href={favIcon}
        type="image/vnd.microsoft.icon"
      />
      {children}
    </>
  );
};

export default SEO;
